"use client";

import { c as _c } from "react/compiler-runtime";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
export default function EditablePlugin(t0) {
  const $ = _c(4);
  const {
    editable
  } = t0;
  const [editor] = useLexicalComposerContext();
  let t1;
  let t2;
  if ($[0] !== editable || $[1] !== editor) {
    t1 = () => {
      editor.setEditable(editable);
    };
    t2 = [editor, editable];
    $[0] = editable;
    $[1] = editor;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}